module.exports = __webpack_public_path__ + "media/images/bg/mosaic/lesson-70ae0395f603686a9e0ca1b249e5332c.jpg";